<template>
  <PopinBase :is-active="route.query.subscribe ? true : false" size="3xs" :is-closable="!isPaying" is-full layout="display" color="flamingo" :is-auto-close="false"  @close="onClose">
    <template #body>
      <MemberSubscribeMain
        class="min-h-full pt-14"
        @pay-start="isPaying = true"
        @pay-end="isPaying = false"
        :is-skippable="false"
        :offer-type="((route?.query?.subscribe ?? '') as any).replace('true', '')"
        @success="() => router.push({ name: 'app', query: { subscribed: 'true'} })"
        v-if="route.query.subscribe"
      />
    </template>
  </PopinBase>
</template>

<script lang="ts" setup>
const route = useRoute()
const router = useRouter()

const isPaying = ref(false)

watch(() => route?.query?.subscribe, (v) => {
  if (v) {
    useNuxtApp().$amplitude.logEvent(`Paywall_Open`, {
      source: route.fullPath
    })
  }
}, { immediate: true })

const onClose = () => {
  router.replace({ query: { ...route.query, subscribe: undefined }})
}
</script>
